import { createContext, useContext } from "react";

export const SAFE_WORKSPACE_PAGES = {
  "assessment/wizard/step-0": ["위험성평가", "평가기준·주기 관리"],
  "assessment/wizard/step-1": ["위험성평가", "위험성평가 실시"],
  "assessment/wizard/step-2": ["위험성평가", "개선대책 관리"],
  "assessment/wizard/step-3": ["위험성평가", "개선결과 확인·승인"],
  "monitoring/tbm": ["현장 안전관리", "TBM 관리"],
  "monitoring/inspection": ["현장 안전관리", "현장 안전점검"],
  "monitoring/actions": ["현장 안전관리", "점검 조치요청·처리"],
  "worker/hazard-review": ["현장 안전관리", "위험요인 제안 검토"],
  "monitoring/education": ["현장 안전관리", "안전보건교육 관리"],
  "monitoring/legal-certs": ["현장 안전관리", "설비·구역 검사·인증 관리"],
  "monitoring/committee": ["운영·보고", "안전보건위원회"],
  "register/cause": ["위험성평가", "유해·위험요인 발굴·등록"],
  "standard/machine": ["기준정보", "설비·구역 정보 관리"],
  "standard/process": ["기준정보", "평가 대상 관리"],
  "standard/location": ["기준정보", "라인 관리"],
  "standard/cause": ["기준정보", "공통 유해·위험요인 관리"],
  "standard/msds": ["기준정보", "MSDS 관리"],
  "register/machine": ["기준정보", "설비·구역–평가 대상 연결"],
  "standard/eval-cycle": ["기준정보", "평가 주기 설정"],
  "worker/hazard-proposal": ["근로자 기능", "유해·위험요인 제안"],
  "worker/action-inbox": ["근로자 기능", "내 조치 업무"],
  "monitoring/integrated-report": ["운영·보고", "보고서"],
  organization: ["운영·보고", "조직·권한 관리"],
};

// An explicit allowlist keeps Home, legacy pages and other systems unchanged.
export const getSafeWorkspacePage = (pathname) => {
  const match = pathname.match(/^\/safe\/[^/]+\/[^/]+\/(.+?)\/?$/);
  const workerMatch = pathname.match(/^\/safe-worker\/[^/]+\/[^/]+\/(hazard-proposal|action-inbox)\/?$/);
  const path = workerMatch ? `worker/${workerMatch[1]}` : match?.[1];
  if (path?.startsWith("assessment/wizard/step-")) return null;
  const page = SAFE_WORKSPACE_PAGES[path];
  return page ? {
    path,
    category: page[0],
    title: page[1],
    compact: ["현장 안전관리", "기준정보"].includes(page[0]) || path === "monitoring/committee",
  } : null;
};

export const SafeWorkspaceContext = createContext(null);
export const useSafeWorkspace = () => useContext(SafeWorkspaceContext);
